// extracted by mini-css-extract-plugin
module.exports = {"projectCatalog":"CatalogSection_projectCatalog__2XU7l","filter":"CatalogSection_filter__2mhf4","section":"CatalogSection_section__1fUZd"};